import React from 'react';

const STATUTS = {
  // Factures
  payee: { label: 'Payée', variant: 'success' },
  impayee: { label: 'Impayée', variant: 'warning' },
  partiellement_payee: { label: 'Partiel', variant: 'info' },
  en_retard: { label: 'En retard', variant: 'danger' },
  // Devis
  brouillon: { label: 'Brouillon', variant: 'neutral' },
  envoye: { label: 'Envoyé', variant: 'info' },
  accepte: { label: 'Accepté', variant: 'success' },
  refuse: { label: 'Refusé', variant: 'danger' },
  // Tenants (admin)
  actif: { label: 'Actif', variant: 'success' },
  suspendu: { label: 'Suspendu', variant: 'danger' },
  // E-invoicing (Super PDP)
  non_transmise: { label: 'Non transmise', variant: 'neutral' },
  pret_a_transmettre: { label: 'Prêt à transmettre', variant: 'warning' },
  DEPOSEE: { label: 'Déposée', variant: 'info' },
  EN_COURS: { label: 'En traitement', variant: 'warning' },
  ACCEPTEE: { label: 'Acceptée', variant: 'success' },
  REFUSEE: { label: 'Refusée', variant: 'danger' },
  REJETEE: { label: 'Rejetée', variant: 'danger' },
};

function StatusBadge({ statut }) {
  const config = STATUTS[statut] || { label: statut, variant: 'neutral' };
  return <span className={`badge badge-${config.variant}`}>{config.label}</span>;
}

export default StatusBadge;
